import { Injectable } from '@angular/core';

import { catchError, map } from 'rxjs/operators';
import { GetFilter, GetPagination } from '@shared/interfacres/request-related';
import { Observable } from 'rxjs';
import {
  CategoriesWithPagination,
  CategoryCreate
} from '@shared/interfacres/category';
import { BaseApiService } from '@data-access/common/base-api.service';

@Injectable({providedIn: 'root'})
export class CategoriesManagerService extends BaseApiService {

  getList()  {
    const requestUrl = `${this.apiUrl}/admin/settings/categories`;
    return this._httpClient.get(requestUrl).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }

  getFiltered(
    name: string,
    filter: GetFilter,
    pagination: GetPagination
  ): Observable<CategoriesWithPagination> {
    let apiUrl = `${this.apiUrl}/admin/settings/categories/paginated?&page=${pagination.page}&limit=${pagination.pageSize}&sortBy=${filter.query}&sortDirection=${filter.order}`;
    if (name) {
      apiUrl += `&search=${name}`;
    }
    return this._httpClient.get<CategoriesWithPagination>(apiUrl).pipe(
      map((response: CategoriesWithPagination) => this.returnResponseData(response)),
      catchError(this.handleError)
    )
  }

  create(data: CategoryCreate) {
    const url = `${this.apiUrl}/admin/settings/categories`;
    return this._httpClient.post(url, data).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

  update(id: number, data: CategoryCreate) {
    const url = `${this.apiUrl}/admin/settings/categories/${id}`;
    return this._httpClient.patch(url, data).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }

  delete(ids: number[]) {
    const url = `${this.apiUrl}/admin/settings/categories`;
    return this._httpClient.delete(url, {body: {ids}}).pipe(
      map((response) => this.returnResponseData(response)),
      catchError(this.handleError)
    );
  }
}
